import { useAlertStore } from "~/stores/useAlertStore";

export default defineNuxtRouteMiddleware(async (to) => {
  const { hasRole, authUser } = useAuth();
  const { setAlert } = useAlertStore();

  // pages every user could reach
  const whitelistPatterns = [
    /^\/?login\/?$/,
    /^\/?users\/activate\/.*\/.*\/?$/,
    /^\/?unauthorized\/?$/,
  ];
  if (whitelistPatterns.find((pattern) => pattern.test(to.path))) return true;

  // unauthenticated users must login
  if (!authUser.value) return "/login/";

  // superuser has super powers
  if (authUser.value.is_superuser) return true;

  // role based permission
  const requiredRole = to.meta.role;

  // warn developers when a role is not specified
  if (!requiredRole) {
    abortNavigation(
      `You forgot to specify a meta role to your page ${to.path}`,
    );
  }

  // allow authorized users to navigate
  if (hasRole(authUser.value, requiredRole)) return true;

  // warn unauthorized users and prevent navigation
  setAlert({
    message: "Non hai i permessi necessari per accedere.",
    type: "warning",
  });
  return abortNavigation();
});
